import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import AdminUsers from "./pages/AdminUsers";
import AdminDomains from "./pages/AdminDomains";
import AdminAuth from "./pages/AdminAuth";
import Dashboard from "./pages/Dashboard";
import { useState, useEffect } from "react";

export default function App() {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const [user, setUser] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		async function checkAuth() {
			try {
				const response = await fetch('/api/me', { credentials: 'include' });
				if (response.ok) {
					const data = await response.json();
					setIsAuthenticated(true);
					setUser(data.data?.user ?? null);
				} else {
					setIsAuthenticated(false);
					setUser(null);
				}
			} catch {
				setIsAuthenticated(false);
				setUser(null);
			} finally {
				setLoading(false);
			}
		}
		checkAuth();
	}, []);

	async function logout() {
		try {
			await fetch('/api/logout', { method: 'POST', credentials: 'include' });
		} catch {
			// ignore
		} finally {
			setIsAuthenticated(false);
			setUser(null);
		}
	}

	if (loading) {
		return <div className="min-h-screen bg-gray-950 text-white flex items-center justify-center">Загрузка...</div>;
	}

	return (
		<HelmetProvider>
			<Router>
				<div className="min-h-screen flex flex-col bg-gray-950">
					<nav className="bg-gray-900 p-4 text-white flex justify-between items-center">
						<Link to={isAuthenticated ? "/dashboard" : "/auth"} className="font-bold text-xl">Shield-AI Admin</Link>
						{isAuthenticated && (
							<div className="flex items-center gap-4">
								<Link to="/admin/users" className="hover:text-gray-300 transition-colors">Пользователи</Link>
								<Link to="/admin/domains" className="hover:text-gray-300 transition-colors">Сайты</Link>
								<Link to="/dashboard" className="hover:text-gray-300 transition-colors">Статистика</Link>
								<button onClick={logout} className="hover:text-gray-300 transition-colors">Выход</button>
							</div>
						)}
					</nav>

					<main className="flex-grow">
						<Routes>
							<Route path="/" element={<Navigate to={isAuthenticated ? "/admin/users" : "/auth"} replace />} />
							<Route path="/auth" element={isAuthenticated ? <Navigate to="/admin/users" replace /> : <AdminAuth setIsAuthenticated={setIsAuthenticated} setUser={setUser} />} />
							<Route path="/dashboard" element={isAuthenticated ? <Dashboard user={user} logout={logout} checkAuth={() => {}} serviceName="Shield-AI Admin" /> : <Navigate to="/auth" replace />} />
							<Route path="/admin/users" element={isAuthenticated ? <AdminUsers /> : <Navigate to="/auth" replace />} />
							<Route path="/admin/domains" element={isAuthenticated ? <AdminDomains /> : <Navigate to="/auth" replace />} />
						</Routes>
					</main>
				</div>
			</Router>
		</HelmetProvider>
	);
}
